import { Switch } from '@mui/material';
import React, { useState } from 'react';
import {
    BudgetProposalWithResourcesT,
    CellRendererParams,
} from 'routes/BudgetModule/config/types';

import { useCallback } from 'react';
import { useUpdateCadrageByChapter } from '../hook';
import DeleteCustomCadrageModal from './DeleteCustomCadrageModal';
import { trackEventClickCadrageByChapterToggle } from '../helper';

export default function ToggleCellRenderer({
    data,
    value,
}: CellRendererParams<
    BudgetProposalWithResourcesT,
    boolean
>): React.ReactElement {
    const [isDeleteCustomCadrageModalOpen, setIsDeleteCustomCadrageModalOpen] =
        useState(false);
    const { mutate: updateCadrageByChapter } = useUpdateCadrageByChapter(
        data?.id,
    );
    const handleChange = useCallback(() => {
        if (data?.hasCustomCadrage) {
            setIsDeleteCustomCadrageModalOpen(true);
        } else {
            updateCadrageByChapter();
        }
        trackEventClickCadrageByChapterToggle(!data?.cadrageByChapter);
    }, []);
    if (!data) return <></>;
    return (
        <>
            <Switch checked={value ?? false} onChange={handleChange} />
            {isDeleteCustomCadrageModalOpen && (
                <DeleteCustomCadrageModal
                    isModalShown={isDeleteCustomCadrageModalOpen}
                    setShowModal={setIsDeleteCustomCadrageModalOpen}
                    budgetProposal={data}
                    updateCadrageByChapter={updateCadrageByChapter}
                />
            )}
        </>
    );
}
